export default __webpack_public_path__ + "static/media/persianaalicantina.f6eec564.jpg";